export default __webpack_public_path__ + "static/media/leftPagination.cdd76f9b.svg";